import { render } from "./AmountCol.vue?vue&type=template&id=6d4e165d"
import script from "./AmountCol.vue?vue&type=script&lang=js"
export * from "./AmountCol.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__